import { StayType, type Lodging } from "@b2bportal/lodging-api";

export const useHomeFeaturesFromHotel = (hotel: Lodging) => {
  const isHomes = hotel.stayType === StayType.Homes;
  if (!isHomes)
    return {
      isHomes,
      maxOccupancy: 0,
      numberOfBedrooms: 0,
      numberOfBathrooms: 0,
    };
  return {
    isHomes,
    maxOccupancy: hotel.homesListingDetails.listingTerms.maxOccupancy,
    numberOfBedrooms:
      hotel.homesListingDetails.listingContent.listingLayout.numberOfBedrooms,
    numberOfBathrooms:
      hotel.homesListingDetails.listingContent.listingLayout.numberOfBathrooms,
  };
};
